import React from 'react';

import Form from './Form';
import * as Sentry from '@sentry/react';

import './App.css';

Sentry.init({
  dsn: 'https://ca1daa032f134b12a82286aeb9b39b41@o37111.ingest.sentry.io/5648096',

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const App = () => {
  return <Form />;
};

export default App;
